import React from "react"
import OneColWrapper from "../technical/OneColWrapper"

const EventsFromPartnerPortalBlock = ({ block }) => {
  return (
    <OneColWrapper
      block={block}
      className="events-from-partnerportal-block pt-0"
    >
      <div dangerouslySetInnerHTML={{ __html: block.code }}></div>
    </OneColWrapper>
  )
}

export default EventsFromPartnerPortalBlock
